import React, { useState } from 'react'
import '../../component/dashboard/dashboard.css'
import logo from '../../assets/logo.png';
import { Link, Outlet, useNavigate } from 'react-router-dom'
import { auth } from '../../firebase' 
import { signOut } from "firebase/auth"; 

const Dashboard = () => {
  const navigate = useNavigate(); 
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); 

  const handleLogout = () => {
    signOut(auth).then(() => {
      navigate('/login');
    }).catch((error) => {
      console.error("Logout Error: ", error);
    });
  };

  const closeMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className='dashboard-wrapper'>
      
      {/* Mobile Overlay */}
      <div 
        className={`menu-overlay ${isMobileMenuOpen ? 'show' : ''}`} 
        onClick={closeMenu}
      ></div>

      <div className={`side-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
        
        <div className="logo-container">
            <img src={logo} alt="App Logo" />
            <h3>TWS AIR INTERNATIONAL</h3>
        </div>
        <hr/>
        
        <div className='menu-container'>
          
          <div className='menu'>
            <Link to='/dashboard/home' className='menu-link' onClick={closeMenu}>Home</Link>
            <Link to='/dashboard/invoices' className='menu-link' onClick={closeMenu}>Invoices</Link>
            <Link to='/dashboard/new-invoice' className='menu-link' onClick={closeMenu}>New Invoice</Link>
            <Link to='/dashboard/create-shipment-invoice' className='menu-link' onClick={closeMenu}>Create Shipment Invoice</Link>
            
            <Link to='/dashboard/cn-upload' className='menu-link' onClick={closeMenu}>CN Upload</Link>

            {/* Booking Report মেনুতে থাকবে, কিন্তু Booking Accounts এখান থেকে সরিয়ে দেওয়া হয়েছে */}
            <Link to='/dashboard/booking-report' className='menu-link' onClick={closeMenu}>Booking Profit Report</Link>
            
            <Link to='/dashboard/payments' className='menu-link' onClick={closeMenu}>Payments</Link>
            <Link to='/dashboard/full-report' className='menu-link' onClick={closeMenu}>Full Report</Link>
            <Link to='/dashboard/combined-report' className='menu-link' onClick={closeMenu}>PRINT ALL BILL</Link>
            
            <Link to='/dashboard/setting' className='menu-link' onClick={closeMenu}>Setting</Link>
          </div>

          <div className='logout-container'>
            <button onClick={handleLogout} className='logout-btn'>
              Logout
            </button>
          </div>

        </div>

      </div>

      <div className='main-container'>
        <button 
          className="mobile-menu-toggle" 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 12H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 6H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <Outlet/>
      </div>
    </div>
  )
}

export default Dashboard